<div id="piece" [formGroup]="shipmentForm">
  <div class="row">
    <div class="col-10 text-start">
      <p
        *ngIf="
          pieceLevelLabelPrint &&
          checkPieceLabelGenerated() &&
          this.shipmentData.status != 'Manifest Failed'
        "
        style="color: red; font-size: 13px">
        *{{ 'shipment.piece.pieceWarningLabel' | translate }}
      </p>
    </div>
    <div class="col-2 text-end">
      <button
        class="me-1 icon-mat-header"
        (click)="AddNewRow()"
        #tooltip="matTooltip"
        [matTooltip]="'shipment.piece.addAnotherPackage' | translate"
        mat-raised-button>
        <em class="bi bi-plus"></em>
      </button>
    </div>
  </div>
  <div class="table-container">
    <ng-container formArrayName="pieces">
      <table aria-describedby="pieceData-table" mat-table [dataSource]="pieceDataSource">
        <ng-container matColumnDef="pieceNo">
          <th id="pieceNo" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.no' | translate }}
          </th>
          <td mat-cell class="text-center" *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              style="display: none"
              class="form-control"
              formControlName="pieceNo"
              value="i+1" />
            <label>{{ i + 1 }}.</label>
          </td>
        </ng-container>

        <ng-container matColumnDef="packagingType">
          <th id="packagingType" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.packagingType' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select
              class="form-control input-dropdown"
              (change)="changePackageType($event.target.value, i)"
              formControlName="packagingType">
              <option *ngFor="let option of packageArray" [value]="option.packagingType">
                {{ option.packagingType }}
              </option>
            </select>
            <app-error-component
              [controlName]="getpieceFormControlId(i, 'packagingType')"></app-error-component>
          </td>
        </ng-container>

        <ng-container matColumnDef="packageWeight">
          <th class="required-field" id="packageWeight" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.weight' | translate }} <br />
            ({{ 'shipment.piece.kg' | translate }})
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              type="number"
              step="any"
              [matTooltipDisabled]="!getpieceFormControlId(i, 'packageWeight').errors"
              [matTooltip]="'shipment.piece.minimumValueUpto3' | translate"
              [ngStyle]="{
                'border-color': getpieceFormControlId(i, 'packageWeight').errors ? 'red' : 'grey'
              }"
              class="text-center form-control input-inside-header"
              formControlName="packageWeight" />
          </td>
        </ng-container>
        <ng-container matColumnDef="packageLength">
          <th class="required-field" id="packageLength" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.length' | translate }} <br />
            ({{ 'shipment.piece.cm' | translate }})
          </th>
          <td class="ps-1" mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              type="number"
              step="any"
              (input)="getVolumetricWeight(i)"
              [matTooltipDisabled]="!getpieceFormControlId(i, 'packageLength').errors"
              [matTooltip]="'shipment.piece.minimumValueUpto3' | translate"
              [ngStyle]="{
                'border-color': getpieceFormControlId(i, 'packageLength').errors ? 'red' : 'grey'
              }"
              class="text-center form-control input-inside-header"
              formControlName="packageLength" />
          </td>
        </ng-container>

        <ng-container matColumnDef="packageWidth">
          <th class="required-field" id="packageWidth" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.width' | translate }} <br />
            ({{ 'shipment.piece.cm' | translate }})
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              type="number"
              step="any"
              (input)="getVolumetricWeight(i)"
              [matTooltipDisabled]="!getpieceFormControlId(i, 'packageWidth').errors"
              [matTooltip]="'shipment.piece.minimumValueUpto3' | translate"
              [ngStyle]="{
                'border-color': getpieceFormControlId(i, 'packageWidth').errors ? 'red' : 'grey'
              }"
              class="text-center form-control input-inside-header"
              formControlName="packageWidth" />
          </td>
        </ng-container>

        <ng-container matColumnDef="volumetricWeight">
          <th id="volumetricWeight" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.volumetric' | translate }} <br />
            {{ 'shipment.piece.weight' | translate }} <br />
            ({{ 'shipment.piece.kg' | translate }})
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              class="text-center form-control input-inside-header"
              formControlName="volumetricWeight" />
          </td>
        </ng-container>

        <ng-container matColumnDef="packageHeight">
          <th class="required-field" id="packageHeight" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.height' | translate }} <br />
            ({{ 'shipment.piece.cm' | translate }})
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              (input)="getVolumetricWeight(i)"
              [matTooltipDisabled]="!getpieceFormControlId(i, 'packageHeight').errors"
              [matTooltip]="'shipment.piece.minimumValueUpto3' | translate"
              [ngStyle]="{
                'border-color': getpieceFormControlId(i, 'packageHeight').errors ? 'red' : 'grey'
              }"
              class="text-center form-control input-inside-header"
              type="number"
              min="0"
              formControlName="packageHeight" />
          </td>
        </ng-container>
        <ng-container matColumnDef="pieceReference">
          <th
            [ngClass]="{ 'required-field': pieceLevelLabelPrint }"
            id="pieceReference"
            mat-header-cell
            *matHeaderCellDef>
            {{ 'shipment.piece.pieceRef' | translate }}#
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              [ngClass]="{
                'border-red':
                  (findDuplicate(i) && i > 0) || getpieceFormControlId(i, 'pieceReference').errors
              }"
              class="form-control input-piece"
              type="text"
              maxlength="35"
              formControlName="pieceReference" />
          </td>
        </ng-container>
        <ng-container matColumnDef="pieceID">
          <th id="pieceID" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.pieceId' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input class="form-control input-piece-id" formControlName="pieceID" />
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th id="status" mat-header-cell *matHeaderCellDef>
            <span *ngIf="pieceLevelLabelPrint">{{ 'shipment.piece.pieceStatus' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <span *ngIf="pieceLevelLabelPrint">
              <input class="form-control input-piece" formControlName="status" />
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="pieceContentDescription">
          <th id="pieceContentDescription" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.description' | translate }}
          </th>

          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              class="form-control input-piece"
              min="0"
              maxlength="70"
              formControlName="pieceContentDescription" />
          </td>
        </ng-container>

        <ng-container matColumnDef="Action">
          <th id="action" mat-header-cell *matHeaderCellDef>
            {{ 'shipment.piece.action' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <div>
              <i
                class="icon-mat-header"
                (click)="openPieceDialog(i)"
                #tooltip="matTooltip"
                [matTooltip]="'shipment.piece.addAdditionalPieces' | translate"
                mat-raised-button>
                <em class="bi bi-plus"></em>
              </i>
              <i
                [matTooltip]="'shipment.piece.delete' | translate"
                class="m-1 icon-mat bi bi-trash"
                (click)="DeleteRow(pieces, i)"></i>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="pieceAction">
          <th id="pieceAction" mat-header-cell *matHeaderCellDef>
            <span *ngIf="pieceLevelLabelPrint && this.shipmentDataExist">
              {{ 'shipment.piece.pieceAction' | translate }}</span
            >
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <span *ngIf="pieceLevelLabelPrint && this.shipmentDataExist">
              <ng-container
                *ngIf="
                  this.shipmentForm.getRawValue().pieces[i]?.status?.toLowerCase() ==
                    'Not Generated'.toLowerCase() &&
                  (this.shipmentData.status == 'Created' ||
                    this.shipmentData.status == 'Partially Label Generated')
                ">
                <i
                  [matTooltip]="'shipment.piece.generateLabel' | translate"
                  class="m-1 icon-mat bi bi-download"
                  (click)="generateIndividualPieceLabel(i)"></i>
              </ng-container>
            </span>
            <span *ngIf="pieceLevelLabelPrint && this.shipmentDataExist">
              <ng-container
                *ngIf="
                  this.shipmentForm.getRawValue().pieces[i]?.status?.toLowerCase() ==
                    'Generated'.toLowerCase() &&
                  (this.shipmentData.status == 'Partially Label Generated' ||
                    this.shipmentData.status == 'Label Generated' ||
                    this.shipmentData.status == 'Manifested' ||
                    this.shipmentData.status == 'Manifest Failed')
                ">
                <i
                  [matTooltip]="'shipment.piece.viewLabel' | translate"
                  class="m-1 icon-mat bi bi-eye"
                  (click)="viewLabel(i)"></i>
              </ng-container>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>

        <tr class="mat-row justify-content-center" *matNoDataRow>
          {{
            'shipment.piece.NoDataAvailable' | translate
          }}
        </tr>
      </table>
      <div class="weight-sum" *ngIf="totalWeight > 0">
        {{ 'shipment.piece.totalWeight' | translate }}:
        <input
          class="form-control input-total-weight"
          type="number"
          min="0"
          readOnly
          [value]="totalWeight" />
      </div>
      <div class="weight-sum"  >
        {{ 'shipment.piece.totalVolumeWeight' | translate }}:
        <input
          class="form-control input-total-weight"
          type="number"
          min="0"
          readOnly
          [value]="totalVolumeWeight" />
      </div>
    </ng-container>
  </div>
</div>
<div [formGroup]="MultiPiecesGroup">
  <ng-template #dialogPieceRef>
    <div class="secondary-details mb-2">
      <span>{{ 'shipment.piece.addAdditionalPieces' | translate }}</span>
    </div>
    <mat-dialog-content class="piece-content">
      <p>{{ 'shipment.piece.noOfPieceLabel' | translate }}</p>
      <div class="col-12">
        <label class="required-field">{{ 'shipment.piece.noPieces' | translate }}</label>
        <input class="form-control" type="number" formControlName="noOfPieces" />
        <app-error-component [controlName]="MultiPiecesGroup.get('noOfPieces')">
        </app-error-component>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button type="submit" class="secondary-btn me-2" (click)="closPieceDialog()">
        {{ 'shipment.piece.close' | translate }}
      </button>
      <button
        type="submit"
        class="primary-btn me-2"
        [disabled]="!isPieceGroupValid()"
        (click)="addMultiplePieces()">
        {{ 'shipment.piece.submit' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
